import { render, staticRenderFns } from "./Esbocos.vue?vue&type=template&id=18062068"
import script from "./Esbocos.vue?vue&type=script&lang=js"
export * from "./Esbocos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports